<template>
  <div>
    <page-header :latestVersionUrl="latestVersionUrl" @log-out="logout" />

    <div align="center" id="licence-details-content">
      
      <div align="left">
        <back-button :backButtonText="backButtonText" @go-back="back" />
      </div>

      <div id="licence-details-info">
        <b-overlay :show="!licence" class="loading-overlay" bg-color="rgb((35, 37, 45)">
          <div v-if="licence">

            <p id="licence-details-title" align="left">{{licence.name}}</p>
            
            <div align="right" id="download-button-div">
              <button id="download-button" @click="downloadLicence">Download</button>
            </div>
            
            <div class="licence-details-section">
              <b-list-group class="licence-section">
                <b-list-group-item class="licence-details-text">
                  <p class="licence-info-title">Organisation ID</p>
                  <p class="licence-info-value">{{organisationId}}</p>
                </b-list-group-item>
                <div class="item-separator-div" align="center">
                  <div class="item-separator" />
                </div>
                <b-list-group-item class="licence-details-text">
                  <p class="licence-info-title">ID</p>
                  <p class="licence-info-value">{{licence.id}}</p>
                </b-list-group-item>  
              </b-list-group>

              <b-list-group class="licence-section">
                <h1 class="licence-section-header">Basic</h1>

                <b-list-group-item class="licence-details-text">
                  <p class="licence-info-title">Version</p>
                  <p class="licence-info-value">{{licence.version}}</p>
                </b-list-group-item>
                <div class="item-separator-div" align="center">
                  <div class="item-separator" />
                </div>
                <b-list-group-item class="licence-details-text">
                  <p class="licence-info-title">Max Version</p>
                  <p class="licence-info-value">{{licence.maxVersion}}</p>
                </b-list-group-item>
                <div class="item-separator-div" align="center">
                  <div class="item-separator" />
                </div>
                <b-list-group-item class="licence-details-text">
                  <p class="licence-info-title">Licence Created</p>
                  <p class="licence-info-value">{{formatDate(licence.created)}}</p>
                </b-list-group-item>
                <div class="item-separator-div" align="center">
                  <div class="item-separator" />
                </div>
                <b-list-group-item class="licence-details-text">
                  <p class="licence-info-title">Instance Duration (Days)</p>
                  <p class="licence-info-value">{{licence.licenceInstanceExpiry / 1000 / 60 / 60 / 24}}</p>
                </b-list-group-item>
              </b-list-group>

              <b-list-group class="licence-section">
                <h1 class="licence-section-header">Limits</h1>

                <b-list-group-item class="licence-details-text">
                  <p class="licence-info-title">Max Output</p>
                  <p class="licence-info-value">{{licence.limits.maxOutputs}}</p>
                </b-list-group-item>
                <div class="item-separator-div" align="center">
                  <div class="item-separator" />
                </div>
                <b-list-group-item class="licence-details-text">
                  <p class="licence-info-title">Max Zones</p>
                  <p class="licence-info-value">{{licence.limits.maxZones}}</p>
                </b-list-group-item>
                <div class="item-separator-div" align="center">
                  <div class="item-separator" />
                </div>
                <b-list-group-item class="licence-details-text">
                  <p class="licence-info-title">Max Resolution (Width)</p>
                  <p class="licence-info-value">{{licence.limits.maxResX}}</p>
                </b-list-group-item>
                <div class="item-separator-div" align="center">
                  <div class="item-separator" />
                </div>
                <b-list-group-item class="licence-details-text">
                  <p class="licence-info-title">Max Resolution (Height)</p>
                  <p class="licence-info-value">{{licence.limits.maxResY}}</p>
                </b-list-group-item>
                <div class="item-separator-div" align="center">
                  <div class="item-separator" />
                </div>
                <b-list-group-item class="licence-details-text">
                  <p class="licence-info-title">Max Module Chains</p>
                  <p class="licence-info-value">{{licence.limits.maxModuleChains}}</p>
                </b-list-group-item>
              </b-list-group>

              <b-list-group class="licence-section">
                <h1 class="licence-section-header">Features</h1>

                <b-list-group-item v-for="(_, feature, index) in licence.features" :id="feature" :key="feature" class="licence-details-text">
                  <div v-show="index" class="feature-item-separator-div" align="center">
                    <div class="item-separator" />
                  </div>
                  <p class="licence-info-title">{{camelToCapitalize(feature)}}</p>
                  <div class="licence-info-value">
                    <img v-show="licence.features[feature]" src="@/assets/success.png" width="20px" />
                    <img v-show="!licence.features[feature]" src="@/assets/false.png" width="20px" />
                  </div>
                </b-list-group-item>
              </b-list-group>

              <b-list-group class="licence-section" v-show="licence.associatedKeys != null && licence.associatedKeys.length > 0">
                <h1 class="licence-section-header">Dongles</h1>

                <b-list-group-item class="licence-details-text" v-for="(dongle, index) in licence.associatedKeys" :key="index">
                  <div class="separator-div" align="center" :id="'separator-' + index">
                    <div class="item-separator" />
                  </div>

                  <span class="dongle-id-text">{{dongle}}</span>
                </b-list-group-item>
              </b-list-group>

              <b-list-group class="licence-section" v-show="licence.associatedBackupKeys != null && licence.associatedBackupKeys.length > 0">
                <h1 class="licence-section-header">Backup Dongles</h1>

                <b-list-group-item class="licence-details-text" v-for="(backupDongle, index) in licence.associatedBackupKeys" :key="backupDongle+index">
                  <div class="separator-div" align="center" :id="'separator-' + index">
                    <div class="item-separator" />
                  </div>

                  <span class="dongle-id-text">{{backupDongle}}</span>

                </b-list-group-item>
              </b-list-group>

              <b-list-group class="licence-section" v-show="licence.associatedPlugins != null && licence.associatedPlugins.length > 0">
                <h1 class="licence-section-header">Plugins</h1>

                <b-list-group-item class="licence-details-text" v-for="(plugin, index) in licence.associatedPlugins" :key="plugin.name+index">
                  <div class="separator-div" align="center" :id="'separator-' + index">
                    <div class="item-separator" />
                  </div>

                  <p class="licence-info-title">{{plugin.name}}</p>
                  <p class="licence-info-value">{{formatDate(plugin.expires)}}</p>
                </b-list-group-item>

              </b-list-group>
            </div>
          </div>
        </b-overlay>
      </div>
    </div>
    <div class="page-footer" />
  </div>
</template>

<script>
import BackButton from './BackButton.vue';
import PageHeader from './PageHeader.vue';
export default {
  components: { PageHeader, BackButton },
  data() {
    return {
      licence: null,
      backButtonText: 'Licences'
    }
  },
  methods: {
    formatDate(date) {
      var dateObj = new Date(date)
      const month = dateObj.toLocaleString('default', { month: 'long' });
      return dateObj.getDate() + " " + month + " " + dateObj.getFullYear()
    },
    logout() {
      this.licence = null
      this.$emit('log-out')
    },
    back() {
      this.licence = null
      this.$emit('re-select-licence')
    },
    async getLicence() {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", "Bearer " + this.accessToken);
      myHeaders.append("Content-Type", "application/json");

      var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      const baseUrl = `https://${process.env.VUE_APP_DEPLOY_ENV === 'LIVE' ? '' : 'stage-'}cast-licensing-api.incrowdsports.com/v1`
      return await fetch(`${baseUrl}/licences/${this.licenceId}`, requestOptions)
        .then(response => response.json())
        .then(data => {
          if (data.data.limits == null) {
            data.data.limits = {
              maxModuleChains: '∞',
              maxOutputs: '∞',
              maxResX: '∞',
              maxResY: '∞',
              maxZones: '∞',
            }
          }
          else {
            if (data.data.limits.maxModuleChains == null) {
              data.data.limits.maxModuleChains = '∞'
            }
            if (data.data.limits.maxOutputs == null) {
              data.data.limits.maxOutputs = '∞'
            }
            if (data.data.limits.maxResX == null) {
              data.data.limits.maxResX = '∞'
            }
            if (data.data.limits.maxResY == null) {
              data.data.limits.maxResY = '∞'
            }
            if (data.data.limits.maxZones == null) {
              data.data.limits.maxZones = '∞'
            }
          }

          if (data.data.features == null) {
            data.data.features = {
              hotBackup: false,
              sunShader: false,
              advancedModuleChains: false,
              nonSquarePixels: false,
              sdiOut: false,
              videoRGB: false
            }
          }

          return data.data
        })
        .catch(error => console.log('error', error));
    },
    async downloadLicence() {
      if (!this.accessToken || !this.licenceId) {
        return;
      }

      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append("Authorization", "Bearer " + this.accessToken);

      var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      const baseUrl = `https://${process.env.VUE_APP_DEPLOY_ENV === 'LIVE' ? '' : 'stage-'}cast-licensing-api.incrowdsports.com/v1`
      return await fetch(`${baseUrl}/licences/${this.licenceId}/instance`, requestOptions)
        .then(response => response.json())
        .then(data => {
          // Start file download.
          var licenceJson = {
            licenceInstanceFileModel: data,
            licenceeDataFileModel: {
              username: this.email,
              company: this.organisationName
            }
          }

          this.download("AgendaName.cstl", JSON.stringify(licenceJson));
          return data
        })
        .catch(error => console.log('error', error));
    },
    // Download function from: https://ourcodeworld.com/articles/read/189/how-to-create-a-file-and-generate-a-download-with-javascript-in-the-browser-without-a-server
    download(filename, text) {
      var element = document.createElement('a');
      element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text));
      element.setAttribute('download', filename);

      element.style.display = 'none';
      document.body.appendChild(element);

      element.click();

      document.body.removeChild(element);
    },
    camelToCapitalize (input) {
      switch (input) {
        case 'videoRGB': return 'Video RGB'
        case 'nonSquarePixels': return 'Pixel Pitch Correction'
        case 'sdiOut': return 'SDI out'
        default: return input.replace(/([a-z])([A-Z])/g, '$1 $2').toLowerCase().replace(/\b./g, a => a.toUpperCase())
      }
    }
  },
  props: {
    accessToken: String,
    licenceId: String,
    email: String,
    organisationId: String,
    organisationName: String,
    latestVersionUrl: String
  },
  watch: {
    licenceId: {
      immediate: true,
      async handler() {
        if (this.licenceId.length > 0){
          this.licence = await this.getLicence()
        }
        else {
          this.licence = null
        }
      }
    }
  },
}
</script>

<style>
#licence-details-content {
  padding-left: 10%;
  padding-right: 10%;
}
#licence-details-info {
  margin-top: 12px;
}
#licence-details-title {
  text-align: left;
}
#download-button-div {
  margin-top: -52px;
}
#download-button {
  width: 30%;
  height: 38px;
  
  background:rgba(73, 76, 85, 1);

  border: 0px;
  border-radius: 4px;
}
.licence-details-section {
  margin-top: 24px;
}
.licence-section {
  background: rgba(35, 37, 45, 1);

  padding-top: 16px;

  border: 1px solid rgba(73, 76, 85, 1);
  border-bottom: 0px;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  border-bottom-left-radius: 0px;
  border-bottom-right-radius: 0px;
}
.licence-details-text {
  padding-left: 20px;

  text-align: left;
  background: rgba(35, 37, 45, 1);
  color:white;

  border: 0px;
  box-sizing: border-box;
}
.licence-info-title {
  float: left;
  width: 45%;

  margin-left: 12px;
}
.licence-info-value {
  float: left;
  width: 45%;

  margin-left: 12px;
}
.feature-item-separator-div {
  margin-top: -8px;
  margin-bottom: 16px;
  padding-left: 8px;
  padding-right: 8px;
}
.item-separator-div {
  margin-top: 0px;
  margin-bottom: 8px;
  padding-left: 32px;
  padding-right: 32px;
}
.separator-div {
  margin-top: -4px;
  margin-bottom: 12px;
  padding-left: 16px;
  padding-right: 16px;
}
#separator-0 {
  display: none;
}
.item-separator {
  border-top: 1px solid rgba(73, 76, 85, 1);
  box-sizing: border-box;
  border-radius: 4px;
}
.licence-section-header {
  margin-top: 12px;
  margin-bottom: 16px;
  margin-left: 32px;

  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 26px;
  line-height: 30px;

  text-align: left;
  background: transparent;
  color: white;
}
.dongle-id-text {
  margin-left: 12px;
}
.page-footer {
  min-height: 50px;
}
@media screen and (max-width: 475px) {
  #licence-details-content {
    padding-left: 16px;
    padding-right: 16px;
  }
  #download-button-div {
    margin-top: 0px;
  }
  #download-button {
    width: 100%; /* The width is 100%, when the viewport is 800px or smaller */
  }
  .licence-section-header {
    margin-left: 8px;
  }
  .licence-info-title {
    margin-left: -12px;
    width: 100%;
  }
  .licence-info-value {
    margin-left: -12px;
    width: 100%;
  }
  .item-separator-div {
    margin-top: 0px;
    margin-bottom: 8px;
    padding-left: 8px;
    padding-right: 8px;
  }
  .separator-div {
    margin-top: -4px;
    margin-bottom: 12px;
    margin-left: -12px;
    margin-right: -12px;
    padding-left: 0px;
    padding-right: 0px;
  }
  .licence-section-header {
    font-family: Roboto;
    font-style: normal;
    font-weight: 500;
    font-size: 20px;
    line-height: 23px;
  }
  .dongle-id-text {
    margin-left: -12px;
  }
}
</style>